export default class CustomerParametersValidationException extends Error {
  public constructor(message?: string) {
    super(message ?? 'Campos preenchidos incorretamente');
    this.name = 'CustomerParametersValidationException';
  }
}
